<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select v-model="params.shopId" clearable placeholder="所属店铺" class="search-item">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <sn-user-search-input
                    class="search-item"
                    @change="
              (a) => {
                params.seller = a;
              }
            "
                ></sn-user-search-input>

                <el-input v-model="params.fullName" placeholder="客户名称" class="search-item"></el-input>
                <el-input v-model="params.companyName" placeholder="公司名称" class="search-item"></el-input>

                <el-button
                    class="add-button"
                    type="success"
                    plain
                    icon="el-icon-plus"
                    size="small"
                    title="新增"
                    @click="add"
                ></el-button>

            </el-row>
            <el-row class="search-row">
                <el-input v-model="params.country" placeholder="城市" class="search-item"></el-input>
                <el-input v-model="params.email" placeholder="公司邮箱" class="search-item"></el-input>

                <el-date-picker
                    type="date"
                    placeholder="上次订单起始时间"
                    v-model="params.finalOrderTime"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-date-picker
                    type="date"
                    placeholder="上次回访截止时间"
                    v-model="params.feedbackTime"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 135"
            class="alibaba-buyer-table"
            @sort-change="sortChange"
        >
            <el-table-column prop="shopName" label="所属店铺" width="100"></el-table-column>
            <el-table-column prop="sellerName" label="销售员" width="80"></el-table-column>

            <el-table-column prop="fullName" label="客户名称" width="150"></el-table-column>
            <el-table-column prop="companyName" label="公司名称" width="200"></el-table-column>
            <el-table-column prop="country" label="城市" width="100"></el-table-column>
            <el-table-column prop="email" label="邮箱" width="300"></el-table-column>

            <el-table-column prop="FINAL_ORDER_TIME" label="上次订单时间" width="160" sortable="custom">
                <template slot-scope="order">{{ $tools.timestampToTime(order.row.finalOrderTime)}}</template>
            </el-table-column>
            <el-table-column prop="orderNumber" label="总订单量" width="60"></el-table-column >
            <el-table-column prop="TOTLE_COST" label="总订单金额($)" width="120" sortable="custom">
                <template slot-scope="order">{{ $tools.parsecost(order.row.totleCost, true)}}</template>
            </el-table-column>

            <el-table-column prop="feedbackTime" label="上次回访时间" width="160">
                <template slot-scope="order">{{ $tools.timestampToTime(order.row.feedbackTime)}}</template>
            </el-table-column>
            <el-table-column prop="feedbackNumber" label="回访次数" width="60"></el-table-column>

            <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="shop">
                    <el-button type="text" size="small" v-on:click="edit(shop.row.id)" v-if="!!shop.row.creator">修改</el-button>

                    <el-button type="text" size="small" v-on:click="info(shop.row.id)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
        ></el-pagination>

        <alibaba-buyer-info :show.sync="showInfo" :buyerId="buyerId" :isRoot="true"></alibaba-buyer-info>
        <alibaba-buyer-add :show.sync="showAdd" :buyerId="buyerId" :isRoot="true" :added="page"></alibaba-buyer-add>
    </div>
</template>


<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
import AlibabaBuyerAdd from './Alibaba-buyer-add.vue';
import AlibabaBuyerInfo from './Alibaba-buyer-info.vue';

export default {
    components: { SnUserSearchInput, AlibabaBuyerInfo, AlibabaBuyerAdd },
    data() {
        return {
            buyerId: null,
            showInfo: false,
            records: null,
            params: {
                shopId: null,
                seller: null,
                total: null,
            },
            shops: [],
            showAdd: false,
        };
    },
    methods: {
        info(id) {
            this.buyerId = id;
            this.showInfo = true;
        },
        sortChange(column, prop, order) {
            this.params.sortName= column.prop
            this.params.sortOrder= column.order ? column.order == "ascending" ? "ASC" : "DESC" : "";
            this.page();
        },
        page(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.$http.post(
                ["alibaba/buyer/page", _this.params],
                [
                    function (data) {
                        _this.params.total = data.total;
                        _this.records = data.records;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        getShops() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        add() {
            this.buyerId = null;
            this.showAdd = true;
        },
        edit(buyerId) {
            this.buyerId = buyerId;
            this.showAdd = true;
        }
    },
    mounted() {
        this.getShops();
        this.page();
    },
};
</script>

<style lang="scss">
</style>